import useTransactionsStore from '@/store/modules/transactions';
import { computed, defineComponent } from 'vue';
import { storeToRefs } from 'pinia';
import { getTransactionChannelType, numberFormat } from '@/utils/helpers';
import moment from 'moment';
import { usePaymentStore } from '@/store/modules/payment';
import { PaymentTypes } from '@/types/payment';
import router from '@/router';
import { WidgetApiServiceTypes } from '@/types/widgetApiService';
import { useKycStore } from '@/store/modules/kyc';
import { KycTypes } from '@/types/kyc';
import { TransactTypes } from '@/types/transact';
var TransactionType = TransactTypes.TransactionType;
export default defineComponent({
    name: 'TransactionDetailsComponent',
    computed: {
        KycTypes() {
            return KycTypes;
        },
    },
    setup() {
        const transactionsStore = useTransactionsStore();
        const { selectedTransaction, selectedChannel, selectedFiatAmountWithoutFees, selectedCurrency, buyFlow, collection, payment, selectedCryptoAmount, selectedCrypto, txType, } = storeToRefs(transactionsStore);
        const paymentStore = usePaymentStore();
        const { currentStep: paymentStep } = storeToRefs(paymentStore);
        const kycStore = useKycStore();
        const { kycStatus } = storeToRefs(kycStore);
        const status = transactionsStore.getTransactionStatus(selectedTransaction.value?.status, selectedTransaction.value?.transactionType);
        const showPendingRefundCopy = computed(() => selectedTransaction.value?.transactionType === 'payment' &&
            selectedTransaction.value?.status === 'pending_refund');
        const transactionTimestamp = moment(selectedTransaction.value?.createdAt).format('MMM DD, YYYY HH:mm A');
        let usdFee = 0;
        switch (selectedTransaction.value?.transactionType) {
            case 'payment':
                usdFee =
                    (selectedTransaction.value?.partnerFeeAmountUSD ?? 0) +
                        (selectedTransaction.value?.serviceFeeAmountUSD ?? 0);
                break;
            case 'collection':
                usdFee =
                    (selectedTransaction.value?.partnerFeeAmountUSD ?? 0) +
                        (selectedTransaction.value?.serviceFeeAmountUSD ?? 0) +
                        (selectedTransaction.value?.networkFeeAmountUSD ?? 0);
                break;
            default:
        }
        const localCurrencyFee = (selectedTransaction.value?.partnerFeeAmountLocal ?? 0) +
            (selectedTransaction.value?.serviceFeeAmountLocal ?? 0) +
            (selectedTransaction.value?.networkFeeAmountLocal ?? 0);
        const viewDepositDetails = () => {
            txType.value = TransactionType.BUY;
            selectedChannel.value = getTransactionChannelType(selectedTransaction.value);
            selectedFiatAmountWithoutFees.value =
                selectedTransaction.value.convertedAmount;
            selectedCurrency.value = {
                currency: selectedTransaction.value.currency,
                editable: true,
            };
            collection.value = {
                ...selectedTransaction.value,
            };
            paymentStep.value = PaymentTypes.PaymentSteps.PAYMENT_2;
            router.push('/payment');
        };
        const viewWalletDetails = () => {
            buyFlow.value = false;
            txType.value = TransactionType.SELL;
            selectedCryptoAmount.value.amount =
                selectedTransaction.value?.settlementInfo.cryptoAmount ?? 0;
            selectedCrypto.value = {
                token: selectedTransaction.value?.settlementInfo
                    .cryptoCurrency ??
                    TransactTypes.Tokens.USDT,
                editable: true,
            };
            payment.value = { ...selectedTransaction.value };
            paymentStep.value = PaymentTypes.SellPaymentSteps.PAYMENT_3;
            router.push('/payment');
        };
        const keyPress = () => {
            console.log();
        };
        return {
            selectedTransaction,
            numberFormat,
            transactionTimestamp,
            status,
            viewDepositDetails,
            viewWalletDetails,
            keyPress,
            WidgetApiServiceTypes,
            kycStatus,
            localCurrencyFee,
            usdFee,
            showPendingRefundCopy,
        };
    },
});
